"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { createContext, useContext, useMemo, useState } from "react";
type SetUnreadDividerSerialNo = (serialNo: number | null | ((current: number | null) => number | null)) => void;
interface UnreadDividerContextValue {
  unreadDividerSerialNo: number | null;
  setUnreadDividerSerialNo: SetUnreadDividerSerialNo;
}
const UnreadDividerContext = createContext<UnreadDividerContextValue | null>(null);
interface UnreadDividerProviderProps {
  readonly initialSerialNo: number | null;
  readonly children: ReactNode;
}
export function UnreadDividerProvider(t0) {
  const $ = _c(5);
  const {
    initialSerialNo,
    children
  } = t0;
  const [unreadDividerSerialNo, setUnreadDividerSerialNo] = useState(initialSerialNo);
  let t1;
  if ($[0] !== unreadDividerSerialNo) {
    t1 = {
      unreadDividerSerialNo,
      setUnreadDividerSerialNo
    };
    $[0] = unreadDividerSerialNo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <UnreadDividerContext.Provider value={value}>{children}</UnreadDividerContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useUnreadDivider() {
  const context = useContext(UnreadDividerContext);
  if (!context) {
    throw new Error("useUnreadDivider must be used within an UnreadDividerProvider");
  }
  return context;
}
export function useUnreadDividerOptional() {
  return useContext(UnreadDividerContext);
}